module.exports = {
  PAGE_LOAD: 'pageload',
};
